<template>
    <section class="charts">
        <!-- {{ cSeriesPrincipal }}
        {{ cSeriesSecondary }}
        
        <button class="btn btn-default" @click="update">Actualizar</button> -->
        <!-- {{ pieOptions }}
        <h1>Pie</h1> -->
        <vue-highcharts :options="pieOptions" ref="pieChart"></vue-highcharts>
    </section>
</template>
<script>
import VueHighcharts from "vue2-highcharts";
// import Drilldown from "highcharts/modules/drilldown.js";
// import * as data from "../assets/data.js";
// import Highcharts from "highcharts";


const data={
    };

export default {
  name:'pie-chart',
  props:{
        title:{
            type:String,
            default:'Titulo Gráfico'
        },
        subtitle:{
            type:String,
            default:'Subtitulo Grafico'
        },
        namePies:{
            type:String,
            default:'Valores Pie'
        },
        seriesPrincipal:{
            type:Array,
            default:function(){
                    return ["Datos", 8];
                }
        }    
  },
  components: {
    VueHighcharts
  },
  data() {
    return {
    //   Highcharts: Highcharts,
      pieOptions: {
        chart: {
            type: "pie",
            options3d: {
                enabled: true,
                alpha: 45
            }
        },
        title: {
            text: this.title
        },
        subtitle:{
            text: this.subtitle
        },
        plotOptions: {
            pie: {
                innerSize: 15,
                depth: 45
            }
        },
        series: [
            {   
                name: this.namePies,
                data:this.seriesPrincipal
            }
        ],
    }
    }
  },
  methods:{
      update(){
        let pie= this.$refs.pieChart;
        // console.log(this.$refs);
        console.log(pie);
        // this.$refs.drilldownChart.removeSeries();
        // console.log('removiendo la series')
        // drill.initHigcharts();
        // this.$refs.drilldownChart.options.series[0].data=this.cSeriesPrincipal;
        // this.$refs.drilldownChart.getChart();
        // this.$refs.drilldownChart.initHigcharts();
        // this.seriesPrincipalNew=this.seriesPrincipal;
        // this.seriesSecondaryNew=this.seriesSecondary;
        // drill.delegateMethod("showLoading", "Loading...");
          console.log('actualizando el grafico')
        //   drilldownChart.getChart();
      },
      load(){
          
      }
  },
  computed:{
      cSeriesPrincipal(){
        //   this.update();
          return this.seriesPrincipal;
      }
  },
  watch:{
      pieOptions(){
        //   this.update();
          return this.pieOptions;
      }
  }
};
</script>
<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/charts/PieChart.vue